import React from 'react'

export const Cart = () => {
    return (
        <>
        <a href="/checkout"><div id="cart"></div>........</a>
        </>
    )
}
